<template>
  <div class="main-visual">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <img src="static/img/icon_score.png" class="img-score" />
      <p class="title">고객이 원하는 시간과 장소로<br v-if="isMobile" />방문하는 <span>차량관리 서비스</span></p>
      <div class="sub-content">
        엔진오일, 배터리 교체 시 <br v-if="isMobile" />13종 프리미엄 안전점검 무상 서비스까지<br />
        국산차, 수입차 21개 브랜드 <br v-if="isMobile" />1,308개 모델 서비스 가능!<br />
        이젠 정비소 가지 말고 <br v-if="isMobile" />집, 사무실에서 정비 받으세요.
      </div>
      <div class="app-download">
        <img @click="googleDown()" :src="googleImg" class="google" />
        <img @click="appleDown()" :src="appImg" class="apple" />
      </div>
      <div class="website-save" v-if="!isMobile">
        <span><a href="//carsuri.co.kr/" target="_blank">카수리 홈페이지</a>에서 누적 43만 건의 정비사례를 만나보세요.</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
      bgImg: 'static/img/main-content/site_main_visual.png',
      googleImg: 'static/img/btn_google_play.png',
      appImg: 'static/img/btn_app_store.png'
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/site_main_visual.png'
        this.googleImg = 'static/img/btn_google_play.png'
        this.appImg = 'static/img/btn_app_store.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/site_main_visual_m.png'
        this.googleImg = 'static/img/mobile/btn_google_play.png'
        this.appImg = 'static/img/mobile/btn_app_store.png'
        this.isMobile = true
      }
    },
    appleDown() {
      window.open('https://apps.apple.com/kr/app/%EC%B9%B4%EC%88%98%EB%A6%AC-%EC%9E%90%EB%8F%99%EC%B0%A8-%EC%B6%9C%EC%9E%A5%EC%A0%95%EB%B9%84-%EC%84%9C%EB%B9%84%EC%8A%A4/id968243793')
    },
    googleDown() {
      window.open('https://play.google.com/store/apps/details?id=com.dpc.carpro2')
    }
  }
}
</script>

<style scoped>
.main-visual {
  width: 100%;
  position: relative;
}
.main-visual .bg {
  width: 100%;
  height: auto;
  display: block;
}

/* pc */
@media (max-width: 1280px) {
  .main-visual .contents .title {
    font-size: 30px;
    color: #000000;
    font-style: normal;

    font-weight: 300;
    margin-bottom: 1.5%;
  }
  .main-visual .contents .title span {
    font-size: 30px;
    color: #000000;
    font-style: normal;

    font-weight: 700;
    margin-bottom: 1.5%;
  }
  .main-visual .contents .sub-content {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 26px;
    color: #444444;
    margin-bottom: 3%;
  }
  .main-visual .contents .app-download .google {
    width: 190px;
    height: auto;
    display: block;
    cursor: pointer;
    margin-right: 1%;
  }
  .main-visual .contents .app-download .apple {
    width: 190px;
    height: auto;
    display: block;
    cursor: pointer;
  }
  .website-save img {
    width: 22px;
    height: auto;
    margin-right: 8px;
  }
  .website-save span {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    color: #444444;
  }
  .website-save span a {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    color: #007def;
    text-decoration-line: underline;
  }
}
@media (min-width: 1280px) {
  .main-visual .contents .title {
    font-size: 2.35vw;
    color: #000000;
    font-style: normal;

    font-weight: 300;
    margin-bottom: 1.5%;
  }
  .main-visual .contents .title span {
    font-size: 2.35vw;
    color: #000000;
    font-style: normal;

    font-weight: 700;
    margin-bottom: 1.5%;
  }
  .main-visual .contents .sub-content {
    font-style: normal;
    font-weight: 300;
    font-size: 1.2vw;
    line-height: 2vw;
    color: #444444;
    margin-bottom: 3%;
  }
  .main-visual .contents .app-download .google {
    width: 15vw;
    height: auto;
    display: block;
    margin-right: 1%;
    cursor: pointer;
  }
  .main-visual .contents .app-download .apple {
    width: 15vw;
    height: auto;
    display: block;
    cursor: pointer;
  }
  .website-save img {
    width: 1.5vw;
    height: auto;
    margin-right: 8px;
  }
  .website-save span {
    font-style: normal;
    font-weight: 300;
    font-size: 1.2vw;
    color: #444444;
  }
  .website-save span a {
    font-style: normal;
    font-weight: 300;
    font-size: 1.2vw;
    color: #007def;
    text-decoration-line: underline;
  }
}
@media (min-width: 641px) {
  .main-visual .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 11% 0 0 15%;
  }
  .main-visual .contents .img-score {
    width: 60px;
    height: auto;
    display: block;
  }
  .main-visual .contents .app-download {
    display: flex;
  }
  .website-save {
    padding-top: 4%;
    display: flex;
    align-items: center;
  }
}
/* mobile */
@media (max-width: 640px) {
  .main-visual .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .main-visual .contents .img-score {
    margin-top: 15%;
    margin-bottom: 6%;
    margin-left: 5%;
    width: 10vw;
    height: auto;
    display: block;
  }
  .main-visual .contents .title {
    margin-left: 5%;
    font-size: 6.5vw;
    color: #000000;
    font-style: normal;

    font-weight: 300;
    margin-bottom: 5%;
    line-height: 11vw;
  }
  .main-visual .contents .title span {
    font-weight: bold;
    font-size: 6.5vw;
  }
  .main-visual .contents .sub-content {
    margin-left: 5%;

    font-style: normal;
    font-weight: 300;
    font-size: 4vw;
    line-height: 7vw;
    color: #444444;
    letter-spacing: -0.5px;
  }
  .main-visual .contents .app-download {
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: center;
    bottom: 5%;
  }
  .main-visual .contents .app-download .google {
    width: 40%;
    height: auto;
    max-height: 100px;
    display: block;
    cursor: pointer;
    margin-right: 5%;
  }
  .main-visual .contents .app-download .apple {
    width: 40%;
    height: auto;
    max-height: 100px;
    display: block;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/MainVisual.vue